export type MessageRequest = {
  requestId: string;
  userMessageContent: string;
  logs: ChatWidgetLog[];
  responseTimeMs: number;
};

export enum ChatWidgetLogLevel {
  Info = 'Info',
  Warning = 'Warning',
  Error = 'Error',
}

export type ChatWidgetLogBase = {
  id: string;
  timestamp: Date;
  agentName?: string | null;
  level: ChatWidgetLogLevel;

  // @deprecated: it's present in MessageRequest
  requestId?: string;

  // @deprecated: it's present in MessageRequest
  userMessageContent?: string;
};

export type ChatWidgetLogWithPlatformData = ChatWidgetLogBase & {
  platformLog: PlatformLog;
};

export type ChatWidgetLogWithChatData = ChatWidgetLogBase & {
  chatLog: ChatLog;
};

export type ChatWidgetLog =
  | ChatWidgetLogWithPlatformData
  | ChatWidgetLogWithChatData;

type PlatformLog = {
  message: string | null;
  jsonData: string | null;
};

type ChatLog = {
  message: string;
  jsonData: string | null;
};
